import type { TableActionSpec } from '@/@vxapp/@Types/ServiceMetadata'

export const BookingOptionsTableActions = [
  {
    id: 'edit',
    title: 'Edit Booking Option',
    icon: 'tabler-pencil',
    color: 'primary',
    emit: 'edit',
  },
  {
    id: 'view',
    title: 'View Booking Option',
    icon: 'tabler-eye',
    color: 'primary',
    emit: 'view',
  },
] as const satisfies readonly TableActionSpec[]
